import { useMemo } from 'react';

interface UseDebitsCalculationProps {
  totalValue: number;
  totalValueEdited: number;
  discountPercentage: string;
  enableManualEdit: boolean;
}

export const useDebitsCalculation = ({
  totalValue,
  totalValueEdited,
  discountPercentage,
  enableManualEdit
}: UseDebitsCalculationProps) => {

  // ✅ Calcular valor base
  const baseValue = useMemo(() => {
    return enableManualEdit && totalValueEdited
      ? totalValueEdited
      : totalValue;
  }, [enableManualEdit, totalValueEdited, totalValue]);

  // ✅ Calcular valor da entrada (amountCharged)
  const amountCharged = useMemo(() => {
    const entryPercentage = discountPercentage;

    if (entryPercentage && baseValue) {
      const entryValue = (parseFloat(entryPercentage) / 100) * baseValue;
      return entryValue;
    }

    return 0;
  }, [baseValue, discountPercentage]);

  // ✅ Calcular valor final (baseValue - entrada)
  const finalValue = useMemo(() => {
    return baseValue - amountCharged;
  }, [baseValue, amountCharged]);

  return {
    baseValue,
    amountCharged,
    finalValue
  };
};